import React from 'react';
import { Container } from 'react-bootstrap';
import { Layout } from '../../components/layout';

export const WebsiteRenewalArticle: React.FC = () => {
  return (
    <Layout title="INFORMATION" subtitle="お知らせ">
      <Container className="my-5">
        <h1>ホームページリニューアルのお知らせ</h1>
        <p><small>2020-03-14</small></p>
        <p>
          弊社ホームページをリニューアルいたしました。
        </p>
      </Container>
    </Layout>
  );
};
